import { render, staticRenderFns } from "./bookmarks.vue?vue&type=template&id=1983ea61&lang=html&"
import script from "./bookmarks.vue?vue&type=script&lang=js&"
export * from "./bookmarks.vue?vue&type=script&lang=js&"
import style0 from "./bookmarks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports